import { ref } from 'vue';
import { defineStore } from 'pinia';
import type Alert from '@/interfaces/Alert';

interface State {
  messages: Alert[];
  timeout: number;
}

const useFlashMessageStore = defineStore({
  id: 'flash-messages',
  state: () => ref<State>({
    messages: [],
    timeout: 5000,
  }),
  actions: {
    pushNotification(alert: Alert): void {
      const exists = this.messages.find((message) => message.id === alert.id);
      if (exists) {
        return;
      }
      this.messages.push(alert);
      if (!alert.duration || alert.duration > 0) {
        setTimeout(() => {
          this.removeNotification(alert);
        }, alert.duration || this.timeout);
      }
    },
    removeNotification(alert: Alert): void {
      const filtered = this.messages.filter((item) => JSON.stringify(item) !== JSON.stringify(alert));
      this.messages = [
        ...filtered,
      ];
    },
    setTimout(duration: number): void {
      this.timeout = duration;
    },
  },
});

export default useFlashMessageStore;
